<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'DFieldBody',
    props: {
      message: {
        type: String,
      },
      type: {
        type: [String, Object],
      },
    },
    render(createElement) {
      return createElement(
        'div',
        { attrs: { class: 'field-body' } },
        this.$slots.default().map((element) => {
          // skip returns and comments
          if (!element.tag) {
            return element;
          }
          if (this.message) {
            return createElement('d-field', { attrs: { message: this.message, type: this.type } }, [element]);
          }
          return createElement('d-field', { attrs: { type: this.type } }, [element]);
        }),
      );
    },
  });
</script>
